// Copyright (C) Lembani Sakala - All rights reserved.
// Lembani Sakala.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.

import React from 'react';
import { Link } from 'react-router-dom';

// import camper from '../../images/camper1.jpg';
import lts from '../../images/lts-rental.jpg';
import courtesy from '../../images/courtesy-rental.jpg';

export const ProductsAndServices = () => {
  return (
    <section
      className="products-and-services-clean py-5"
      id="productsAndServices"
      style={{
        background: '#f8fafc',
      }}
    >
      <div className="container">
        <h2 className="text-center fw-bold display-4 mb-2" style={{letterSpacing: 1}}>Our Services</h2>
        <p className="col-md-7 mx-auto text-center text-secondary fs-5 mb-5">
          Our car rental services offer a wide selection of vehicles to suit every traveler's needs.
        </p>
        <div className="row g-4 justify-content-center">
          <div className="col-12 col-md-6">
            <div className="card border-0 shadow-sm rounded-4 overflow-hidden h-100 bg-white products-card-clean transition-hover" style={{cursor: 'pointer', transition: 'transform 0.18s'}} onMouseOver={e => (e.currentTarget.style.transform = 'translateY(-6px) scale(1.02)')} onMouseOut={e => (e.currentTarget.style.transform = 'none')}>
              <img src={lts} className="card-img-top" alt="Long & Short Term Car Rental" style={{height: 260, objectFit: 'cover'}} />
              <div className="card-body d-flex flex-column justify-content-between p-4">
                <h3 className="h4 fw-bold mb-3 text-dark">Long & Short Term Car Rental</h3>
                <p className="text-secondary mb-3" style={{fontSize: '1rem'}}>
                  Flexible rentals for days, months, or years, always at the best rates. 
                  Choose from a wide variety of vehicles to fit your needs.
                </p>
                <Link to="/car-rental/long-and-short-term" className="btn btn-r btn-lg w-100">Book A Vehicle</Link>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6">
            <div className="card border-0 shadow-sm rounded-4 overflow-hidden h-100 bg-white products-card-clean transition-hover" style={{cursor: 'pointer', transition: 'transform 0.18s'}} onMouseOver={e => (e.currentTarget.style.transform = 'translateY(-6px) scale(1.02)')} onMouseOut={e => (e.currentTarget.style.transform = 'none')}>
              <img src={courtesy} className="card-img-top" alt="Courtesy Car Rental" style={{height: 260, objectFit: 'cover'}} />
              <div className="card-body d-flex flex-column justify-content-between p-4">
                <h3 className="h4 fw-bold mb-3 text-dark">Courtesy Car Rental</h3>
                <p className="text-secondary mb-3" style={{fontSize: '1rem'}}>
                  If your car is in an accident, request a courtesy vehicle through your insurer. We'll handle the handover and billing, so you stay on the road with no hassle.
                </p>
                <Link to="/car-rental/courtesy" className="btn btn-outline-danger btn-lg w-100">Explore</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
